import { checkRecaptchaApi } from '@tools/api/api';
import { setupScript } from '@tools/utils/script-utils';
import * as React from 'react';

export const useRecaptcha = () => {
    const [shouldShowCaptchaV2, setShouldShowCaptchaV2] = React.useState(false);
    const [isCaptchaChecked, setIsCaptchaChecked] = React.useState(false);

    const captchaRef = (React.useRef(
        null
    ) as unknown) as React.MutableRefObject<HTMLInputElement>;

    const setupCaptchaV3 = () => {
        window.grecaptcha.ready(() => {
            void window.grecaptcha
                .execute(process.env.RECAPTCHAV3_SITEKEY, {
                    action: 'checkifbot'
                })
                .then(async scoreToken => {
                    if (captchaRef.current) {
                        captchaRef.current.value = scoreToken;
                    }
                    const res = await checkRecaptchaApi({
                        userToken: scoreToken
                    });
                    if (res?.showCaptchaToUser) {
                        setShouldShowCaptchaV2(true);
                    }
                });
        });
    };

    React.useEffect(() => {
        setupScript(
            `https://www.google.com/recaptcha/api.js?render=${process.env.RECAPTCHAV3_SITEKEY}`,
            setupCaptchaV3
        );
    }, []);

    return {
        shouldShowCaptchaV2,
        captchaRef,
        isCaptchaChecked,
        setIsCaptchaChecked
    };
};
